var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoggedIn)?_c('div',{staticClass:"user-info"},[_c('div',{staticClass:"user-info__email"},[_vm._v(_vm._s(_vm.email))]),_c('div',[_c('a',{staticClass:"user-info__logout",on:{"click":_vm.logout}},[_vm._v("Log out")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }